export const metaDataConstants = {
    DISCIPLINE: 'metaData/discipline',
    BUILDING: 'metaData/building',
    FLOOR: 'metaData/floor'
}